import React , {Fragment} from 'react';
import { Field, reduxForm } from 'redux-form';
import {simpleInputField} from "../components/InputRenderers";
import LoadingIcon from '../../img/three-dots.svg';

const validate = (values) => {
    const errors = {};
    if (!values.password || values.password === '') {
        errors.password = "پسورد جدید را وارد کنید" ;
    }
    if (!values.repassword || values.repassword === '') {
        errors.repassword = "تکرار پسورد را وارد کنید" ;
    }
    else if (values.password !== values.repassword) {
        errors.repassword = "تکرار پسورد درست نیست." ;
    }
    return errors;
};


let ChangePassForm = props => {
    const { handleSubmit, error, loading} = props;
    return (
        <Fragment>
            <div className="popUpTitle font-size_20">
                <Field name="password" component={simpleInputField} label="رمز عبور" type="password" />
                <Field name="repassword" component={simpleInputField} label="تکرار رمز عبور" type="password" />
            </div>
            <div className="popUpOptions textInLeft topColumnMargin">
                <span className="redColor leftMargin" onClick={handleSubmit}>تایید</span>
                <span className="">انصراف</span>
            </div>
        </Fragment>
    );
};

export const formName = "ChangePassForm";

const ChangePass = reduxForm({
    // a unique name for the form
    enableReinitialize: true,
    form: formName,
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate
})(ChangePassForm);

export default ChangePass;